import { fetchHil, fetchHil2 } from "../utils";
import moment from "moment";

export default {
  namespaced: true,
  state: {
    comments: [],
    lastLoading: null,
    targetId: null,
    extraAttributes: {},
    filter: () => true
  },
  getters: {
    orderedComments: state => {
      return state.comments.filter(state.filter).sort((a, b) => {
        return moment(b.createdAt).isAfter(a.createdAt) ? -1 : 1;
      });
    }
  },
  mutations: {
    setComments(state, { comments, targetId, extraAttributes, filter }) {
      state.comments = comments;
      state.targetId = targetId;
      state.extraAttributes = extraAttributes;
      state.filter = filter;
    }
  },
  actions: {
    async pushComment(
      { state, dispatch },
      { content, extraAttributes = {}, targetId = null }
    ) {
      if (content) {
        await fetchHil2(
          "post",
          `/comments/for/${state.targetId || targetId}?owner=hil`,
          {
            body: {
              content,
              ...state.extraAttributes,
              ...extraAttributes
            }
          }
        );
      }
      await dispatch("fetchComments", { ...state });
    },
    async fetchComments(
      { state, commit },
      { targetId = null, extraAttributes = null, filter = null }
    ) {
      if (targetId === null) {
        targetId = state.targetId;
      }
      if (extraAttributes === null) {
        extraAttributes = state.extraAttributes;
      }
      if (filter === null) {
        filter = state.filter;
      }

      if (targetId) {
        const resp = await (await fetchHil(`/comments/for/${targetId}`)).json();
        commit("setComments", {
          comments: resp,
          targetId,
          extraAttributes,
          filter
        });
      }
    }
  }
};
